import React from 'react';
import Styles from './MeuFinanciamentoDebito.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import RedButton from '@/components/atoms/RedButton';

function MeuFinanciamentoDebito() {
  return (
    <section id="meu-financiamento-debito">
      <ContainerHome24>
        <h3 className="debito-titulo">Vantagens do pagamento em débito automático</h3>
        <p className="debito-paragrafo">
          Você sabia que ao trocar seu pagamento de <b>boleto para débito automático</b>, você conta
          com diversas vantagens? <br />
          <br /> Confira abaixo todos os benefícios de pagar suas parcelas do financiamento em
          débito automático:
        </p>

        <div className="is-mob">
          <CustomEmblaCarouselHome24 enableBullets detectBulletCount hideOverflow>
            {({ className }) => (
              <>
                <div className={`slide ${className}`}>
                  <img src="assets/meu-financiamento/ic_money.svg" alt="investimento" />
                  <p className="text">
                    Ao utilizar o pagamento em débito automático, você poderá receber uma parte do
                    valor da parcela de volta direto em sua conta Santander.
                  </p>
                </div>
                <div className={`slide ${className}`}>
                  <img src="assets/meu-financiamento/ic_debito.svg" alt="debito automatico" />
                  <p className="text">
                    O débito automático permite facilidade no momento do pagamento, já que não será
                    necessário gerar os boletos todos os meses.
                  </p>
                </div>
              </>
            )}
          </CustomEmblaCarouselHome24>
        </div>

        <div className="is-desk">
          <div className={`slide`}>
            <img src="assets/meu-financiamento/ic_money.svg" alt="investimento" />
            <p className="text">
              Ao utilizar o pagamento em débito automático, você poderá receber uma parte do valor
              da parcela de volta direto em sua conta Santander.
            </p>
          </div>
          <div className={`slide`}>
            <img src="assets/meu-financiamento/ic_debito.svg" alt="debito automatico" />
            <p className="text">
              O débito automático permite facilidade no momento do pagamento, já que não será
              necessário gerar os boletos todos os meses.
            </p>
          </div>
        </div>

        <div className="debito-content-text">
          <h3 className="debito-titulo">Veja como funciona o cashback nas suas parcelas</h3>
          <p className="debito-paragrafo">
            Mantenha o débito automático até o final do contrato e ganhe dinheiro de volta. Você
            pode cadastrar o débito automático a qualquer momento.
            <br />
            <span>*Consultar sua elegibilidade para o cashback</span>
          </p>
        </div>

        <div className="debito-parcelas">
          <div className="box-branco">
            <span className="box-titulo">Prazo</span>
            <h4 className="box-negrito">60 parcelas</h4>
          </div>

          <img
            className="debito-seta"
            src="assets/meu-financiamento/ic_arrow_box.svg"
            alt="icone de seta"
          />

          <div className="box-branco">
            <span className="box-titulo">Parcela de</span>
            <h4 className="box-negrito">R$ 1.000</h4>
          </div>

          <img
            className="debito-seta"
            src="assets/meu-financiamento/ic_arrow_box.svg"
            alt="icone de seta"
          />

          <div className="box-branco">
            <span className="box-titulo">Cashback de</span>
            <h4 className="box-negrito">R$ 18,00</h4>
            <span className="box-subtitulo">a cada parcela paga</span>
          </div>

          <img
            className="debito-seta"
            src="assets/meu-financiamento/ic_arrow_box.svg"
            alt="icone de seta"
          />

          <div className="box-branco">
            <span className="box-titulo">Vai receber</span>
            <h4 className="box-negrito">R$ 1.080,00</h4>
            <span className="box-subtitulo">até o final do contrato</span>
          </div>
        </div>
        <RedButton
          href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento:5a-dobra&int_campaign=alterar-forma-de-pagamento"
          target="_blank"
          className="debito-btn-red"
        >
          Alterar forma de pagamento
        </RedButton>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default MeuFinanciamentoDebito;
